// Modules
import React, { useMemo, useState } from 'react'
import { Formik, Form, Field } from 'formik'
import { Button, Loading, TextField } from '@dasa-health/components-react'

// Application
import { maskCellPhone } from 'utils'
import { SystemOutlineWarning } from '@dasa-health/icons'

// Components
import { Text, Container, Title, WrapperFildUpdateContacts, ContainerButtons } from './styles'
import { PhoneSchema } from 'validators/schema/PhoneValidator'
import { validateEmail } from 'utils/validateEmail'
import { UpdateContactsInicialValues } from 'typings/unico'
import { useHistory } from 'react-router-dom'

interface Props {
    initialValues: UpdateContactsInicialValues
    handleSubmit: (values: UpdateContactsInicialValues) => void
    isSubmitting: boolean
}

type Event = React.ChangeEvent<HTMLInputElement>

export const FormUpdateConcacts: React.FC<Props> = ({ initialValues, isSubmitting, handleSubmit }) => {
    const [email, setEmail] = useState('')
    const history = useHistory()
    const handleFieldChange = (event: Event, handleChange: (e: Event) => void) => {
        event.target.value = maskCellPhone(event.target.value)
        handleChange(event)
    }

    const onBackButton = () => {
        history.goBack()
    }

    const emailError = useMemo(() => validateEmail(email), [email])

    return (
        <Formik initialValues={initialValues} onSubmit={values => handleSubmit(values)} validationSchema={PhoneSchema}>
            {({ values, touched, errors, handleChange }) => {
                const showPhoneHelperText = touched.cellphone && errors.cellphone
                const infoPhoneHelper = 'Ex.: (00) 00000-0000'
                return (
                    <Form autoComplete="off" data-testid="cellphone-form">
                        <WrapperFildUpdateContacts>
                            <Field
                                as={TextField}
                                className="form__phone-field"
                                data-testid="phone-field"
                                disabled={isSubmitting}
                                helperText={showPhoneHelperText ? errors.cellphone : infoPhoneHelper}
                                id="cellphone"
                                inputmode="numeric"
                                label="Celular"
                                maxLength={15}
                                name="cellphone"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFieldChange(e, handleChange)}
                                type="tel"
                                value={values?.cellphone}
                                variant={showPhoneHelperText ? 'error' : undefined}
                            />
                        </WrapperFildUpdateContacts>
                        <WrapperFildUpdateContacts>
                            <Field
                                as={TextField}
                                className="form__email-field"
                                data-testid="email-input"
                                disabled={isSubmitting}
                                helperText={emailError && !!email.length ? 'Digite um e-mail válido' : undefined}
                                id="email"
                                label="E-mail"
                                name="email"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setEmail(e.target.value)
                                    handleChange(e)
                                }}
                                value={values?.email}
                                variant={emailError && !!email.length ? 'error' : undefined}
                            />
                        </WrapperFildUpdateContacts>
                        <Container data-testid="warning-service-is-down-component">
                            <Title>
                                <SystemOutlineWarning color="#0037FF" fontSize="1.5rem" /> Reconhecimento facial
                            </Title>
                            <Text>
                                Pra concluir a atualização de cadastro, você vai realizar o reconhecimento facial e verificar sua
                                identidade com segurança.
                            </Text>
                        </Container>
                        <ContainerButtons>
                            <Button disabled={isSubmitting} onClick={onBackButton} type="button" variant="tertiary">
                                Voltar
                            </Button>
                            <Button
                                disabled={
                                    !values?.cellphone || !!errors?.cellphone || (values.email ? !!emailError : false) || isSubmitting
                                }
                                type="submit"
                            >
                                Confirmar novo contato{' '}
                                {isSubmitting && <Loading color="#888" size={'sm'} style={{ marginLeft: '1rem' }} />}
                            </Button>
                        </ContainerButtons>
                    </Form>
                )
            }}
        </Formik>
    )
}
